import React from "react";
import {Link, withRouter} from "react-router-dom";
import {confirmAlert} from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class Promotion extends React.Component {
  constructor() {
    super();
    this.state = {
      showingAlert: false,
      showingPromo1: true,
      showingPromo2: false,
      showingPromo3: false,
      promo1Color: "BLACK",
      promo2Color: "BLACK"
    };
  }

  handleClickShowAlert() {
    this.setState({
      showingAlert: true
    });

    setTimeout(() => {
      this.setState({
        showingAlert: false
      });
    }, 2000);
  }

  showPromo(promoId) {
    this.setState({ "showingPromo1": false });
    this.setState({ "showingPromo2": false });
    this.setState({ "showingPromo3": false });

    const field = "showingPromo" + promoId;
    this.setState({ [field]: true });
  }

  setColor(promoId, color) {
    if (promoId === 1) {
      this.setState({
        promo1Color: color
      })
    } else if (promoId === 2) {
      this.setState({
        promo2Color: color
      })
    }
  }

  buyNow = (promoId) => {
    if (promoId === 1) {
      /*if(true) {
        confirmAlert({
          title: 'Sold Out Item',
          message: 'This MightyWifi CLOUD is currently sold out here, so we are redirecting you to our Amazon Shop. Is that okay?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => window.location = "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });
      }*/
      /*if (this.state.promo1Color === "WHITE") {
        confirmAlert({
          title: 'Sold Out Item',
          message: 'Thank you for your interest in our Mightywifi Cloud White. We are currently sold out of White color but Black color is still available. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => window.location = "https://www.amazon.com/dp/B07NDGFV71?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });
      }
      else if (this.state.promo1Color === "BLUE") {
        confirmAlert({
          title: 'Sold Out Item',
          message: 'Thank you for your interest in our Mightywifi Cloud Blue. We are currently sold out of Blue color but Black color is still available. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => window.location = "https://www.amazon.com/dp/B07NDGFV71?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });
      }
      else */if (this.state.promo1Color === "BLACK") {
        this.props.history.push({
          pathname: "/buy/device",
          state: {
            promotion: '120',
            buy_option: 'buy_device_with_data',
            useType: 'USA',
            color: this.state.promo1Color
          }
        });
        /*confirmAlert({
          title: 'Sold Out Item',
          message: 'Thank you for your interest in our Mightywifi Cloud Black. We are currently sold out of Black color. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => window.location = "https://www.amazon.com/dp/B07NDGFV71?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });*/
      }
    }
    else if (promoId === 2) {
      if (this.state.promo1Color === "BLACK") {
        this.props.history.push({
          pathname: "/buy/device",
          state: {
            promotion: '105',
            buy_option: 'buy_device_with_data',
            useType: 'USA',
            color: this.state.promo1Color
          }
        });
      }
    }
    else {
      /*if (this.state.promo2Color === "WHITE") {
        confirmAlert({
          title: 'Sold Out Item',
          message: 'Thank you for your interest in our Mightywifi Cloud White. We are currently sold out of White color but Black color is still available. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => window.location = "https://www.amazon.com/dp/B07NDGFV71?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });
      }
      else if (this.state.promo2Color === "BLUE") {
        confirmAlert({
          title: 'Sold Out Item',
          //message: 'This MightyWifi CLOUD is currently sold out here, so we are redirecting you to our Amazon Shop. Is that okay?',
          message: 'Thank you for your interest in our Mightywifi Cloud Blue. We are currently sold out of Blue color but Black color is still available. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
          buttons: [
            {
              label: 'Yes',
              //onClick: () => window.location = this.state.promo1Color === "WHITE" ? "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp" : "https://www.amazon.com/dp/B088BBQJJY?ref=myi_title_dp"
              //onClick: () => window.location = "https://www.amazon.com/dp/B083ZJ8QG8/ref=twister_B0889X16NV?_encoding=UTF8&psc=1"
              onClick: () => window.location = "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });
      }
      else */if (this.state.promo2Color === "BLACK") {
        /*confirmAlert({
          title: 'Pre-order Only',
          message: 'This MightyWifi CLOUD is for preorder only. All preorders will be fulfilled Starting 6/22/20. Are you interested in ordering?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                this.props.history.push({
                  pathname: "/buy/device",
                  state: {
                    promotion: promoId === 1 ? '159' : '139',
                    buy_option: 'buy_device_with_data',
                    useType: 'USA',
                    color: this.state.promo2Color
                  }
                });
              }
            },
            {
              label: 'No'
            }
          ]
        });*/
        /*confirmAlert({
          title: 'Sold Out Item',
          message: 'Thank you for your interest in our Mightywifi Cloud Black. We are currently sold out of Black color. Can we redirect you to Amazon\'s Mightywifi Black device for purchase?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => window.location = "https://www.amazon.com/dp/B07W5JH8RH?ref=myi_title_dp"
            },
            {
              label: 'No'
            }
          ]
        });*/
        this.props.history.push({
          pathname: "/buy/device",
          state: {
            promotion: '79',
            buy_option: 'buy_device_with_data',
            useType: 'USA',
            color: this.state.promo2Color
          }
        });
      }
    }
  };

  render() {
    const clearStyle = {
      clear: "both"
    };
    const PaddingStyle = {
      paddingLeft: "5%",
      paddingRight: "5%"
    };

    const strongStyle = {
      fontSize: "1.2em"
    };

    const strongStyleBlue = {
      fontSize: "1.2em",
      color: "#0076be"
    };

    // Checking stock
    const hasStock = true;
    //const hasStock = false;

    return (
        <section className="section promo-section" style={{background: "#fff", padding: "60px 0"}}>

          <div className="container d-view">
            <div className="row">

              <div className="col-lg-4">
                <div className="promoitem text-center">
                  <p className="promo-label">
                    LIMITED TIME
                  </p>
                  {/*<p className="promo-image">
                    <div id="color1" className="" style={{ display: this.state.promo1Color == 'WHITE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color2" className="" style={{ display: this.state.promo1Color == 'BLACK' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color3" className="" style={{ display: this.state.promo1Color == 'BLUE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-blue.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>*/}
                  <p className="promo-image">
                    <div id="color1" className="" style={{ display: "block" }}>
                      <img src="/images/mightywifi-cloud-v3.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi CLOUD<span className="d-break bold400 mt-2">W/ 50GB U.S. DATA <span className="bold600">And</span><br/>1GB GLOBAL DATA</span></h5>
                  </p>
                  <p className="promo-price">
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$159</span>*/}
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$165.90</span>*/}
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$169</span>*/}
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$140</span>*/}
                    <span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$120</span>
                  </p>
                  <p className="promo-text"></p>
                  <div class="col-md-12"><div class="line p-0 mb-4"></div></div>
                  {
                    /*(!hasStock) ? (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>White</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Black</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Blue</a>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo1Color == 'WHITE') ?  ` active` : "")} onClick={ () => this.setColor(1, 'WHITE') }>White</a>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo1Color == 'BLACK') ?  ` active` : "")} onClick={ () => this.setColor(1, 'BLACK') }>Black</a>
                          <a className={`btn btn-white s_btn` + ((this.state.promo1Color == 'BLUE') ?  ` active` : "")} onClick={ () => this.setColor(1, 'BLUE') }>Blue</a>
                        </p>
                    )*/
                  }
                  {
                    (!hasStock) ? (
                        <p className="header_btn">
                          <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <a className="btn btn-white btn-none" onClick={ () => this.showPromo(1) }>SEE MORE</a>
                          {/*<Link className="btn btn-orange" to={{
                            pathname: "/buy/device",
                            state : {
                              promotion : '159',
                              buy_option : 'buy_device_with_data',
                              useType : 'USA',
                              color : this.state.promo1Color
                            }
                          }}>
                            BUY NOW
                          </Link>*/}
                          <button className="btn btn-orange" onClick={ () => this.buyNow(1) }>BUY NOW</button>
                        </p>
                    )
                  }
                </div>
              </div>

              <div className="col-lg-4">
                <div className="promoitem text-center">
                  <p className="promo-label">
                    LIMITED TIME
                  </p>
                  {/*<p className="promo-image">
                    <div id="color1" className="" style={{ display: this.state.promo1Color == 'WHITE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color2" className="" style={{ display: this.state.promo1Color == 'BLACK' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color3" className="" style={{ display: this.state.promo1Color == 'BLUE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-blue.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>*/}
                  <p className="promo-image">
                    <div id="color1" className="" style={{display: "block"}}>
                      <img src="/images/mightywifi-cloud-v3.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi CLOUD<span className="d-break bold400 mt-2">W/ 20GB U.S. DATA <span className="bold600">OR</span><br/>1GB GLOBAL DATA</span>
                    </h5>
                  </p>
                  <p className="promo-price">
                    <span className="promo-discount-price bold100">$190</span> <span
                      className="promo-org-price bold600">$105</span>
                  </p>
                  <p className="promo-text"></p>
                  <div className="col-md-12">
                    <div className="line p-0 mb-4"></div>
                  </div>
                  {
                    (!hasStock) ? (
                        <p className="header_btn">
                          <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <a className="btn btn-white btn-none" onClick={() => this.showPromo(2)}>SEE MORE</a>
                          <button className="btn btn-orange" onClick={() => this.buyNow(2)}>BUY NOW</button>
                        </p>
                    )
                  }
                </div>
              </div>

              <div className="col-lg-4">
                <div className="promoitem text-center">
                  <p className="promo-label">
                    LIMITED TIME
                  </p>
                  {/*<p className="promo-image">
                    <div id="colors1" className="active" style={{ display: this.state.promo2Color == 'WHITE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block active"/>
                    </div>
                    <div id="colors2" className="" style={{ display: this.state.promo2Color == 'BLACK' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="colors3" className="" style={{ display: this.state.promo2Color == 'BLUE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-blue.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>*/}
                  <p className="promo-image">
                    <div id="color1" className="" style={{ display: "block" }}>
                      <img src="/images/mightywifi-cloud-v3.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi CLOUD<span className="d-break bold400 mt-2">W/ 3GB U.S. DATA <span className="bold600">OR</span><br/>1GB GLOBAL DATA</span></h5>
                  </p>
                  <p className="promo-price">
                    {/*<span className="promo-discount-price bold100">$160</span> <span className="promo-org-price bold600">$139</span>*/}
                    {/*<span className="promo-discount-price bold100">$160</span> <span className="promo-org-price bold600">$126.40</span>*/}
                    {/*<span className="promo-discount-price bold100">$160</span> <span className="promo-org-price bold600">$129</span>*/}
                    <span className="promo-discount-price bold100">$170</span> <span className="promo-org-price bold600">$79</span>
                  </p>
                  <p className="promo-text"></p>
                  <div class="col-md-12"><div class="line p-0 mb-4"></div></div>
                  {
                    /*(!hasStock) ? (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>White</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Black</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Blue</a>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo2Color == 'WHITE') ?  ` active` : "")} onClick={ () => this.setColor(2, 'WHITE') }>White</a>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo2Color == 'BLACK') ?  ` active` : "")} onClick={ () => this.setColor(2, 'BLACK') }>Black</a>
                          <a className={`btn btn-white s_btn` + ((this.state.promo2Color == 'BLUE') ?  ` active` : "")} onClick={ () => this.setColor(2, 'BLUE') }>Blue</a>
                        </p>
                    )*/
                  }
                  {
                    (!hasStock) ? (
                        <p className="header_btn">
                          <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <a className="btn btn-white btn-none" onClick={ () => this.showPromo(3) }>SEE MORE</a>
                          {/*<Link to="/buy/device/119" className="btn btn-orange">BUY NOW</Link>*/}
                          {/*<Link className="btn btn-orange" to={{
                            pathname: "/buy/device",
                            state : {
                              promotion : '139',
                              buy_option : 'buy_device_with_data',
                              useType : 'USA',
                              color : this.state.promo2Color
                            }
                          }}>
                            BUY NOW
                          </Link>*/}
                          <button className="btn btn-orange" onClick={ () => this.buyNow(3) }>BUY NOW</button>
                          {/*<Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>*/}
                        </p>
                    )
                  }
                </div>
              </div>

              {/*<div className="col-lg-4">
                <div className="promoitem text-center">
                  <p className="promo-label">
                    COMING SOON
                  </p>
                  <p className="promo-image">
                    <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block"/>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi Cloud Pro</h5>
                  </p>
                  <p className="promo-price">
                    &nbsp;
                  </p>
                  <div class="col-md-12"><div class="line-s"></div></div>
                  <p className="promo-text mb-3 p-3 text-left">
                    - AI (Artificial Intelligence)<br/>
                    - Dialogue Translation<br/>
                    - WPS (Wireless Priority Services)
                  </p>
                  <p className="header_btn">
                    <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                  </p>
                </div>
              </div>*/}

              <div className="col-lg-12">
                <div id="promo1" className="promoitem promodetail" style={{ display: this.state.showingPromo1 ? "block": "none" }}>
                  <div className="icon-top"></div>
                  <div className="promodetail-group">
                    <span className="bold600 d-break">U.S.</span>
                    <p className="bold400">
                      <span className="point-blue">50GB 4G/LTE DATA FOR 30 DAYS</span> <br/>
                      <span className="promodetail-note">(* After 50GB is used up, the device will not work until a new data plan is recharged.)</span>
                    </p>
                    <span className="bold600 d-break pb-3">AND</span>
                    <span className="bold600 d-break">GLOBAL</span>
                    <p className="bold400 pb-2">
                      <span className="point-blue">1GB 4G/LTE DATA FOR 30 DAYS</span><br/>
                      (* Download our app for data usages and instant recharge options. The device will not work without a data plan)
                    </p>
                    {/* <p className="header_btn">
                    <Link to="/buy/device/159" className="btn btn-orange">BUY NOW</Link>
                  </p> */}
                  </div>
                </div>

                <div id="promo2" className="promoitem promodetail" style={{ display: this.state.showingPromo2 ? "block": "none" }}>
                  <div className="icon-top"></div>
                  <div className="promodetail-group">
                    <span className="bold600 d-break">U.S.</span>
                    <p className="bold400">
                      <span className="point-blue">20GB 4G/LTE DATA FOR 30 DAYS</span> <br/>
                      <span className="promodetail-note">(* After 20GB is used up, the device will not work until a new data plan is recharged.)</span>
                    </p>
                    <span className="bold600 d-break pb-3">OR</span>
                    <span className="bold600 d-break">GLOBAL</span>
                    <p className="bold400 pb-2">
                      <span className="point-blue">1GB 4G/LTE DATA FOR 30 DAYS</span><br/>
                      (* Download our app for data usages and instant recharge options. The device will not work without a data plan)
                    </p>
                    {/*  <p className="header_btn">
                    <Link to="/buy/device/119" className="btn btn-orange">BUY NOW</Link>
                  </p> */}
                  </div>
                </div>

                <div id="promo3" className="promoitem promodetail" style={{ display: this.state.showingPromo3 ? "block": "none" }}>
                  <div className="icon-top"></div>
                  <div className="promodetail-group">
                    <span className="bold600 d-break">U.S.</span>
                    <p className="bold400">
                      <span className="point-blue">3GB 4G/LTE DATA FOR 30 DAYS</span> <br/>
                      <span className="promodetail-note">(* After 3GB is used up, the device will not work until a new data plan is recharged.)</span>
                    </p>
                    <span className="bold600 d-break pb-3">OR</span>
                    <span className="bold600 d-break">GLOBAL</span>
                    <p className="bold400 pb-2">
                      <span className="point-blue">1GB 4G/LTE DATA FOR 30 DAYS</span><br/>
                      (* Download our app for data usages and instant recharge options. The device will not work without a data plan)
                    </p>
                    {/*  <p className="header_btn">
                    <Link to="/buy/device/119" className="btn btn-orange">BUY NOW</Link>
                  </p> */}
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="container m-view">
            <div className="row">

              <div className="col-12">
                <div className="promoitem text-center mb-4">
                  <p className="promo-label">
                    LIMITED TIME
                  </p>
                  {/*<p className="promo-image">
                    <div id="color1" className="" style={{ display: this.state.promo1Color == 'WHITE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color2" className="" style={{ display: this.state.promo1Color == 'BLACK' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color3" className="" style={{ display: this.state.promo1Color == 'BLUE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-blue.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>*/}
                  <p className="promo-image">
                    <div id="color1" className="" style={{ display: "block" }}>
                      <img src="/images/mightywifi-cloud-v3.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi CLOUD<span className="m-break bold400">W/ 50GB U.S. DATA <span className="bold600">And</span><br/>1GB GLOBAL DATA</span></h5>
                  </p>
                  <p className="promo-price">
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$159</span>*/}
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$165.90</span>*/}
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$169</span>*/}
                    {/*<span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$140</span>*/}
                    <span className="promo-discount-price bold100">$210</span> <span className="promo-org-price bold600">$120</span>
                  </p>
                  <div class="col-md-12"><div class="line p-0 mb-4"></div></div>
                  {
                    /*(!hasStock) ? (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>White</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Black</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Blue</a>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo1Color == 'WHITE') ?  ` active` : "")} onClick={ () => this.setColor(1, 'WHITE') }>White</a>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo1Color == 'BLACK') ?  ` active` : "")} onClick={ () => this.setColor(1, 'BLACK') }>Black</a>
                          <a className={`btn btn-white s_btn` + ((this.state.promo1Color == 'BLUE') ?  ` active` : "")} onClick={ () => this.setColor(1, 'BLUE') }>Blue</a>
                        </p>
                    )*/
                  }
                  {
                    (!hasStock) ? (
                        <p className="header_btn">
                          <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                        </p>
                    ) : (
                        <p className="header_btn">
                          {/*<Link className="btn btn-orange" to={{
                            pathname: "/buy/device",
                            state : {
                              promotion : '159',
                              buy_option : 'buy_device_with_data',
                              useType : 'USA',
                              color : this.state.promo1Color
                            }
                          }}>
                            BUY NOW
                          </Link>*/}
                          <button className="btn btn-orange" onClick={ () => this.buyNow(1) }>BUY NOW</button>
                        </p>
                    )
                  }
                  <div className="text-left">
                    <span className="bold600 m-break">U.S.</span>
                    <p className="bold400">
                      <span className="point-blue">50GB 4G/LTE DATA FOR 30 DAYS </span><br/>
                      <span className="promodetail-note">(* After 50GB is used up, the device will not work until a new data plan is recharged.)</span>
                    </p>
                    <span className="bold600 m-break pb-3">AND</span>
                    <span className="bold600 m-break">GLOBAL</span>
                    <p className="bold400 pb-2">
                      <span className="point-blue">1GB 4G/LTE DATA FOR 30 DAYS</span><br/>
                      <span className="promodetail-note">(* Download our app for data usages and instant recharge options. The device will not work without a data plan)</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="promoitem text-center mb-4">
                  <p className="promo-label">
                    LIMITED TIME
                  </p>
                  {/*<p className="promo-image">
                    <div id="color1" className="" style={{ display: this.state.promo1Color == 'WHITE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color2" className="" style={{ display: this.state.promo1Color == 'BLACK' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="color3" className="" style={{ display: this.state.promo1Color == 'BLUE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-blue.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>*/}
                  <p className="promo-image">
                    <div id="color1" className="" style={{display: "block"}}>
                      <img src="/images/mightywifi-cloud-v3.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi CLOUD<span className="d-break bold400 mt-2">W/ 20GB U.S. DATA <span className="bold600">OR</span><br/>1GB GLOBAL DATA</span></h5>
                  </p>
                  <p className="promo-price">
                    <span className="promo-discount-price bold100">$190</span> <span
                      className="promo-org-price bold600">$105</span>
                  </p>
                  <div className="col-md-12">
                    <div className="line p-0 mb-4"></div>
                  </div>
                  {
                    (!hasStock) ? (
                        <p className="header_btn">
                          <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <button className="btn btn-orange" onClick={() => this.buyNow(2)}>BUY NOW</button>
                        </p>
                    )
                  }
                  <div className="text-left">
                    <span className="bold600 m-break">U.S.</span>
                    <p className="bold400">
                      <span className="point-blue">20GB 4G/LTE DATA FOR 30 DAYS </span><br/>
                      <span className="promodetail-note">(* After 20GB is used up, the device will not work until a new data plan is recharged.)</span>
                    </p>
                    <span className="bold600 m-break pb-3">OR</span>
                    <span className="bold600 m-break">GLOBAL</span>
                    <p className="bold400 pb-2">
                      <span className="point-blue">1GB 4G/LTE DATA FOR 30 DAYS</span><br/>
                      <span className="promodetail-note">(* Download our app for data usages and instant recharge options. The device will not work without a data plan)</span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="promoitem text-center mb-4">
                  <p className="promo-label">
                    LIMITED TIME
                  </p>
                  {/*<p className="promo-image">
                    <div id="colors1" className="active" style={{ display: this.state.promo2Color == 'WHITE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-white.png" alt="" className="img-fluid mx-auto d-block active"/>
                    </div>
                    <div id="colors2" className="" style={{ display: this.state.promo2Color == 'BLACK' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                    <div id="colors3" className="" style={{ display: this.state.promo2Color == 'BLUE' ? "block": "none" }}>
                      <img src="/images/mightywifi-cloud-blue.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>*/}
                  <p className="promo-image">
                    <div id="color1" className="" style={{ display: "block" }}>
                      <img src="/images/mightywifi-cloud-v3.png" alt="" className="img-fluid mx-auto d-block"/>
                    </div>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi CLOUD<span className="m-break bold400">W/ 3GB U.S. DATA <span className="bold600">OR</span><br/>1GB GLOBAL DATA</span></h5>
                  </p>
                  <p className="promo-price">
                    {/*<span className="promo-discount-price bold100">$160</span> <span className="promo-org-price bold600">$139</span>*/}
                    {/*<span className="promo-discount-price bold100">$160</span> <span className="promo-org-price bold600">$126.40</span>*/}
                    {/*<span className="promo-discount-price bold100">$160</span> <span className="promo-org-price bold600">$129</span>*/}
                    <span className="promo-discount-price bold100">$170</span> <span className="promo-org-price bold600">$79</span>
                  </p>
                  <p className="promo-text"></p>
                  {
                    /*(!hasStock) ? (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>White</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Black</a>
                          <a className={`btn btn-white s_btn mr-15 btn-disabled`}>Blue</a>
                        </p>
                    ) : (
                        <p className="header_btn">
                          <label className="display_block bold600">Please select color</label>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo2Color == 'WHITE') ?  ` active` : "")} onClick={ () => this.setColor(2, 'WHITE') }>White</a>
                          <a className={`btn btn-white s_btn mr-15` + ((this.state.promo2Color == 'BLACK') ?  ` active` : "")} onClick={ () => this.setColor(2, 'BLACK') }>Black</a>
                          <a className={`btn btn-white s_btn` + ((this.state.promo2Color == 'BLUE') ?  ` active` : "")} onClick={ () => this.setColor(2, 'BLUE') }>Blue</a>
                        </p>
                    )*/
                  }
                  {
                    (!hasStock) ? (
                        <p className="header_btn">
                          <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                        </p>
                    ) : (
                        <p className="header_btn">
                          {/*<Link to="/buy/device/119" className="btn btn-orange">BUY NOW</Link>*/}
                          {/*<Link className="btn btn-orange" to={{
                            pathname: "/buy/device",
                            state : {
                              promotion : '139',
                              buy_option : 'buy_device_with_data',
                              useType : 'USA',
                              color : this.state.promo2Color
                            }
                          }}>
                            BUY NOW
                          </Link>*/}
                          <button className="btn btn-orange" onClick={ () => this.buyNow(3) }>BUY NOW</button>
                          {/*<Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>*/}
                        </p>
                    )
                  }
                  <div className="text-left">
                    <span className="bold600 m-break">U.S.</span>
                    <p className="bold400">
                      <span className="point-blue">3GB 4G/LTE DATA FOR 30 DAYS</span> <br/>
                      <span className="promodetail-note">(* After 3GB is used up, the device will not work until a new data plan is recharged.)</span>
                    </p>
                    <span className="bold600 m-break pb-3">OR</span>
                    <span className="bold600 m-break">GLOBAL</span>
                    <p className="bold400 pb-2">
                      <span className="point-blue">1GB 4G/LTE DATA FOR 30 DAYS</span><br/>
                      <span className="promodetail-note">(* Download our app for data usages and instant recharge options. The device will not work without a data plan)</span>
                    </p>
                  </div>
                </div>
              </div>

              {/*<div className="col-12">
                <div className="promoitem text-center">
                  <p className="promo-label">
                    COMING SOON
                  </p>
                  <p className="promo-image">
                    <img src="/images/mightywifi-cloud-black.png" alt="" className="img-fluid mx-auto d-block"/>
                  </p>
                  <p className="promo-title">
                    <h5 className="SansSerif bold600">MightyWifi Cloud Pro</h5>
                  </p>
                  <p className="promo-text mb-3 p-3 text-left">
                    - AI (Artificial Intelligence: Alexa)<br/>
                    - Dialogue Translation<br/>
                    - WPS (Wireless Priority Services)
                  </p>
                  <p className="header_btn">
                    <Link to="" className="btn btn-white btn-disabled">BUY NOW</Link>
                  </p>
                </div>
              </div>*/}

            </div>
          </div>

        </section>
    );
  }
}

//export default Promotion;
export default withRouter(Promotion);



// WEBPACK FOOTER //
// ./src/layout/Promotion.js